import { Link } from "react-router-dom";
import { Seo } from "../components/layout/Seo";
import { PageHero } from "../components/layout/PageHero";
import { BrendanConsole } from "../components/brendan/BrendanConsole";
import { Eyebrow, Reveal } from "../components/motion/Reveal";

const principles = [
  ["AI-assisted, human-verified", "The concept pairs automated event detection with human review before alerts are escalated."],
  ["Clear notifications", "Designed to tell the right people what happened, where and when — without noise."],
  ["Structured workflows", "Each event is intended to carry a log of who reviewed it and what was done."],
  ["Built responsibly", "Privacy, security and appropriate oversight are core design considerations."],
];

export default function BrendanPage() {
  return (
    <>
      <Seo title="Brendan — Round-the-Clock Intelligence (In Development) | TechCare" path="/brendan"
        description="Brendan is an intelligent-monitoring product in development by TechCare Technologies. Explore the conceptual interface for AI-assisted event detection." />
      <PageHero eyebrow="Product · In development" testid="brendan-hero"
        lines={["Brendan —", <span key="r" className="tc-copper-text">Round-the-Clock</span>, "Intelligence."]}
        lead="A proprietary intelligent-monitoring product under development by TechCare Technologies. Everything shown here is a conceptual illustration of the direction we are exploring." />
      <section className="bg-[#0C0A09] pb-24 text-stone-100">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
          <Reveal><BrendanConsole /></Reveal>
        </div>
      </section>
      <section className="bg-[#FAFAF9] py-20 text-stone-900 sm:py-28">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
          <Eyebrow light>Design principles</Eyebrow>
          <div className="mt-10 grid gap-4 md:grid-cols-2">
            {principles.map(([t, d], i) => (
              <Reveal key={t} delay={(i % 2) * 0.08} className="rounded-[22px] border border-stone-300 bg-white p-8">
                <p className="font-mono text-xs text-orange-700">0{i + 1}</p>
                <p className="mt-6 font-display text-2xl">{t}</p>
                <p className="mt-2 text-sm leading-relaxed text-stone-600">{d}</p>
              </Reveal>
            ))}
          </div>
          <div className="mt-12 rounded-[22px] border border-amber-300 bg-amber-50 p-6 text-sm leading-relaxed text-amber-900" data-testid="brendan-disclaimer">
            <strong className="font-semibold">Important:</strong> Brendan is not yet available. It does not currently provide operational monitoring,
            emergency response, police or emergency-service integrations, or guaranteed autonomous threat detection. Features may change as development continues.
          </div>
          <Link to="/contact?type=contact" data-testid="brendan-interest-btn"
            className="mt-10 inline-flex h-12 items-center rounded-full bg-stone-900 px-7 text-sm font-semibold text-white transition-colors hover:bg-orange-700">
            Register interest in Brendan
          </Link>
        </div>
      </section>
    </>
  );
}
